import React from "react";
import { ApartmentOutlined } from "@mui/icons-material";
import {
  Badge,
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import EmptyResult from "components/Shared/Lottie/EmptyResult";
import { Link } from "react-router-dom";

const BranchAssignmentDistrictTab = ({ districtsDetail }) => {
  // Check if districtsDetail is an array and has data
  const districts =
    districtsDetail && Array.isArray(districtsDetail) ? districtsDetail : [];

  return (
    <Grid item xs={12}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={3}
      >
        <Box display="inline-flex" alignItems="center" gap={1.5}>
          <Badge badgeContent={districts.length} color="primary">
            <ApartmentOutlined style={{ color: "gray" }} />
          </Badge>

          <Typography style={{ fontWeight: 500 }}>Districts</Typography>
        </Box>
      </Box>

      <Divider />
      <Box p={2}>
        {districts.length > 0 ? (
          <DistrictCard districts={districts} />
        ) : (
          <EmptyResult height={150} />
        )}
      </Box>
    </Grid>
  );
};

export default BranchAssignmentDistrictTab;

const DistrictCard = ({ districts = [] }) => {
  // Filter out any invalid districts if necessary
  const validDistricts = districts.filter(
    (district) => district?.id && district?.label
  );

  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {validDistricts?.length > 0 ? (
        validDistricts.map((district) => (
          <div key={district?.id} className="group">
            <Link to={`/app/crm/district/${district?.id}/detail`}>
              <Card
                className="h-full transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl"
                sx={{
                  borderRadius: 2,
                  "&:hover": {
                    boxShadow:
                      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                  },
                }}
              >
                <CardContent sx={{ padding: 2 }}>
                  <div className="flex items-center gap-3">
                    <div className="rounded-full bg-blue-100 p-2 transition-colors group-hover:bg-blue-200">
                      <ApartmentOutlined
                        sx={{
                          fontSize: 20,
                          color: "primary.main",
                        }}
                      />
                    </div>
                    <Typography
                      variant="body2"
                      className="line-clamp-2 font-medium"
                    >
                      {district.label} {/* Display the label of the district */}
                    </Typography>
                  </div>
                </CardContent>
              </Card>
            </Link>
          </div>
        ))
      ) : (
        <EmptyResult height={150} />
      )}
    </div>
  );
};
